import CityBreaks from './CityBreaks';

export default CityBreaks;
